export default __webpack_public_path__ + "media/images/icons_fc/outilsblanc-612d44f0039e221525cb5d40aa0b1b07.png";